import { render, staticRenderFns } from "./mailers.vue?vue&type=template&id=9e0d7952"
import script from "./mailers.vue?vue&type=script&lang=js"
export * from "./mailers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports